module.exports = __webpack_public_path__ + "images/emoji/no_entry_sign.22de0265cc4daab70f55.png";